import Image from 'next/image';

import styles from './style.module.css';
interface CardImageProps {
  image?: string;
  classNames?: string;
  height?: number;
  width?: number;
  alt?: string;
}
export default function CardImage({
  image,
  classNames = '',
  height = 400,
  width = 400,
  alt,
}: CardImageProps) {
  return (
    <div className={`${styles.cardImage} ${classNames}`}>
      {image && (
        <Image
          src={image}
          layout={'intrinsic'}
          alt={alt || ''}
          height={height}
          width={width}
        />
      )}
    </div>
  );
}
